// eslint-disable-next-line import/no-cycle
import Link from './link';
import Injectable from '../di/injectable';

@Injectable()
export default class EmptyLink implements Link {
  setNext(): Link {
    return this;
  }

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-empty-function
  next(): void {}
}
